import { render } from "./ResetHcpiDialog.vue?vue&type=template&id=073be47e"
import script from "./ResetHcpiDialog.vue?vue&type=script&lang=js"
export * from "./ResetHcpiDialog.vue?vue&type=script&lang=js"
script.render = render

export default script